(function() {
  const SR = window.SpeechRecognition || window.webkitSpeechRecognition;
  if (!SR) {
    document.querySelectorAll('[data-voice-btn]').forEach(b => (b.hidden = true));
    return;
  }

  // ---- Overlay helpers ----
  const overlay = document.getElementById('voice-overlay');
  const partialEl = overlay ? overlay.querySelector('#voice-partial') : null;
  const langEl = overlay ? overlay.querySelector('#voice-lang') : null;

  let activeStop = null; // points to current stop() for ESC/close

  function showOverlay(lang, accentFromBtn) {
    if (!overlay) return;
    overlay.hidden = false;
    overlay.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('voice-overlay-open');
    document.body && document.body.classList.add('voice-overlay-open');
    if (langEl) langEl.textContent = lang ? `Language: ${lang}` : '';
    // inherit accent color from the clicked mic (if set)
    if (accentFromBtn) {
      overlay.style.setProperty('--voice-accent', getComputedStyle(accentFromBtn).getPropertyValue('--voice-accent') || '');
    }
  }
  function hideOverlay() {
    if (!overlay) return;
    overlay.hidden = true;
    overlay.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('voice-overlay-open');
    document.body && document.body.classList.remove('voice-overlay-open');
    if (partialEl) partialEl.textContent = '';
  }

  function bindOverlayOnce(getStopFn) {
    if (!overlay || overlay.__bound) return;
    overlay.__bound = true;
    const closeEls = overlay.querySelectorAll('[data-voice-close]');
    const handleClose = () => {
      const s = activeStop || getStopFn();
      if (typeof s === 'function') s();
      else hideOverlay();
    };
    closeEls.forEach(el => el.addEventListener('click', handleClose));
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') handleClose();
    });
  }

  // ---- Button binding ----
  function findTargetInput(btn) {
    const targetId = btn.getAttribute('data-target-input');
    if (targetId) {
      const byId = document.getElementById(targetId);
      if (byId) return byId;
    }
    let el = btn.previousElementSibling;
    while (el) {
      if (el.tagName === 'INPUT' && (el.name === 'q' || el.type === 'search')) return el;
      el = el.previousElementSibling;
    }
    const form = btn.closest('form[action="/search"]') || btn.closest('form');
    return form ? form.querySelector('input[name="q"], input[type="search"]') : null;
  }

  // Optional: smarter IN language pick (fallback to en-IN)
  const SUPPORTED_IN = new Set(['en-IN','hi-IN','bn-IN','te-IN','ta-IN','mr-IN','gu-IN','kn-IN','ml-IN','pa-IN','ur-IN','or-IN']);
  const BASE_TO_IN = { en:'en-IN', hi:'hi-IN', bn:'bn-IN', te:'te-IN', ta:'ta-IN', mr:'mr-IN', gu:'gu-IN', kn:'kn-IN', ml:'ml-IN', pa:'pa-IN', ur:'ur-IN', or:'or-IN' };
  function pickLang(btn) {
    const attr = btn.getAttribute('data-voice-lang');
    if (attr && SUPPORTED_IN.has(attr)) return attr;
    const saved = localStorage.getItem('voiceLang');
    if (saved && SUPPORTED_IN.has(saved)) return saved;
    const prefs = navigator.languages || [navigator.language || ''];
    for (const l of prefs) {
      const norm = (l || '').replace('_','-');
      if (SUPPORTED_IN.has(norm)) return norm;
      const base = norm.split('-')[0]; if (BASE_TO_IN[base]) return BASE_TO_IN[base];
    }
    return 'en-IN';
  }

  function bind(btn) {
    if (!btn || btn.__voiceBound) return;
    const input = findTargetInput(btn);
    if (!input) { btn.hidden = true; return; }
    btn.hidden = false;
    btn.__voiceBound = true;

    let recognizing = false, recognition;

    const stop = () => {
      if (!recognizing) return;
      try { recognition.stop(); } catch(_) {}
      recognizing = false;
      btn.classList.remove('listening');
      btn.setAttribute('aria-pressed', 'false');
      hideOverlay();
    };

    const start = () => {
      if (recognizing) return;
      recognition = new SR();
      const lang = pickLang(btn);
      recognition.lang = lang;
      recognition.interimResults = true;
      recognition.maxAlternatives = 1;
      recognition.continuous = false;

      btn.classList.add('listening');
      btn.setAttribute('aria-pressed', 'true');
      recognizing = true;
      input.focus();

      // Show overlay
      showOverlay(lang, btn);
      activeStop = stop;               // allow ESC/close to stop current session
      bindOverlayOnce(() => stop);     // one-time wiring of overlay controls

      recognition.onresult = (e) => {
        let transcript = '';
        for (let i = e.resultIndex; i < e.results.length; i++) {
          transcript += e.results[i][0].transcript;
        }
        transcript = transcript.trim();
        input.value = transcript;

        // Live text in overlay
        if (partialEl) partialEl.textContent = transcript;

        // Wake predictive search
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
        const kev = new KeyboardEvent('keyup', { bubbles: true, key: 'a' });
        Object.defineProperty(kev, 'keyCode', { get: () => 65 });
        Object.defineProperty(kev, 'which', { get: () => 65 });
        input.dispatchEvent(kev);
      };

      recognition.onerror = () => stop();
      recognition.onend = () => {
        btn.classList.remove('listening');
        btn.setAttribute('aria-pressed', 'false');
        recognizing = false;
        hideOverlay();

        const val = (input.value || '').trim();
        if (val.length) {
          const form = input.closest('form');
          if (form) form.submit(); // remove if you prefer not to auto-submit
        }
      };

      try { recognition.start(); } catch(_) {}
    };

    btn.addEventListener('click', () => (recognizing ? stop() : start()));
  }

  // Bind existing buttons
  document.querySelectorAll('[data-voice-btn]').forEach(bind);

  // Bind future buttons (search drawer content)
  new MutationObserver(muts => {
    for (const m of muts) {
      for (const node of m.addedNodes || []) {
        if (!(node instanceof HTMLElement)) continue;
        if (node.matches?.('[data-voice-btn]')) bind(node);
        node.querySelectorAll?.('[data-voice-btn]').forEach(bind);
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
